export const DEFAULT_TRIAL_PERIOD_DAYS = 14;
